import { useDispatch, useSelector } from "react-redux";
import type { RootState, AppDispatch } from "./store";

// RTK에 TypeScript를 적용하기 위한 hooks
export const useAppDispatch = useDispatch.withTypes<AppDispatch>();
export const useAppSelector = useSelector.withTypes<RootState>();
